import {
  GetMembersParams,
  GetMembersResponse,
  MemberAssignRoleForm,
  MemberCourseAccessForm,
  MemberInviteForm,
  GetSingleMemberResponse,
  GetInvitedMembersResponse,
  MemberAcceptInviteForm,
  GetInvitationDetailsResponse,
} from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const getMembers = async (params: GetMembersParams) => {
  const response = await axios.get<GetMembersResponse>(ENDPOINTS.app.members, { params });
  return response.data;
};

export const getSingleMember = async (id: string) => {
  const response = await axios.get<GetSingleMemberResponse>(`${ENDPOINTS.app.members}/${id}`);
  return response.data;
};

export const deleteMember = async (id: string) => {
  const response = await axios.delete(`${ENDPOINTS.app.members}/${id}`);
  return response.data;
};

export const inviteMember = async (data: MemberInviteForm) => {
  const response = await axios.post(`${ENDPOINTS.app.members}/invite`, data);
  return response.data;
};

export const assignMemberRole = async (data: MemberAssignRoleForm) => {
  const response = await axios.post(`${ENDPOINTS.app.members}/assign`, data);
  return response.data;
};

export const updateMemberCourseAccess = async (data: MemberCourseAccessForm) => {
  const response = await axios.post(`${ENDPOINTS.app.members}/course-access`, data);
  return response.data;
};

export const getInvitedMembers = async () => {
  const response = await axios.get<GetInvitedMembersResponse>(`${ENDPOINTS.app.members}/invited`);
  return response.data;
};

export const cancelInvitation = async (email: string) => {
  const response = await axios.delete(`${ENDPOINTS.app.members}/invite`, {
    params: { email },
  });
  return response.data;
};

export const getInvitationDetails = async (invitationId: string) => {
  const response = await axios.get<GetInvitationDetailsResponse>(
    `${ENDPOINTS.app.members}/invite/${invitationId}`
  );
  return response.data;
};

export const acceptInvitation = async (data: MemberAcceptInviteForm) => {
  const response = await axios.post(`${ENDPOINTS.app.members}/invite/confirm`, data);
  return response.data;
};

export const updateLastActive = async () => {
  const response = await axios.put(`${ENDPOINTS.app.members}/last-active`);
  return response.data;
};
